import React from "react";
import { Menu, Dropdown } from "antd";
import ZIcon, { Icons } from "@atoms/ZIcon";

interface BundledProductRowFormOptionsProps {
	readonly toggleBundleProductOptional: () => void;
	readonly deleteBundleProductChild: () => void;
	readonly onEditDrawerOpen: () => void;
	readonly isReadonly?: boolean;
	readonly isOptional?: boolean;
	readonly enableOnlyDelete?: boolean;
}

// interface ProductRowDropDown =
export const ProductRowDropDown: React.FC<
	BundledProductRowFormOptionsProps
> = ({
	isReadonly,
	isOptional,
	onEditDrawerOpen,
	deleteBundleProductChild,
	toggleBundleProductOptional,
	...props
}) => (
	<Menu {...props}>
		{!props.enableOnlyDelete && (
			<Menu.Item onClick={onEditDrawerOpen}>
				{" "}
				{isReadonly ? "View Product" : "Edit Product"}
			</Menu.Item>
		)}

		{!isReadonly && !props.enableOnlyDelete && (
			<Menu.Item onClick={toggleBundleProductOptional}>
				{isOptional ? "Remove it as optional" : "Make Optional"}
			</Menu.Item>
		)}

		{!isReadonly && (
			<Menu.Item
				className="text-red-4"
				onClick={deleteBundleProductChild}
			>
				Remove
			</Menu.Item>
		)}
	</Menu>
);

export const BundledProductRowFormOptions: React.FC<
	BundledProductRowFormOptionsProps
> = props => {
	return (
		<Dropdown overlay={<ProductRowDropDown {...props} />}>
			<ZIcon
				data-testid="more-options-dropdown-trigger"
				name={Icons.MOREVERTICAL}
				size="sm"
				fill
			/>
		</Dropdown>
	);
};
